export default __webpack_public_path__ + "static/media/line-drag-drop-blue.c51eece3.svg";